import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | BrightLife Physio Point</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

            <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Privacy Policy
                </h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Privacy Policy</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div className="container my-5 legal-page">
    
      <p>
        BrightLife Physio Point respects your privacy and is committed to
        protecting your personal information. This Privacy Policy explains how
        we collect, use, and safeguard your data in accordance with the Digital
        Personal Data Protection Act, 2023 (India).
      </p>

      <h3>Information We Collect</h3>
      <ul>
        <li>Name, phone number, email address</li>
        <li>Appointment and enquiry details</li>
        <li>Communication via WhatsApp or contact forms</li>
        <li>Website usage data (via analytics tools)</li>
      </ul>

      <h3>How We Use Your Information</h3>
      <ul>
        <li>To book and manage appointments</li>
        <li>To communicate regarding treatments and follow-ups</li>
        <li>To improve our services and website experience</li>
        <li>For internal records and legal compliance</li>
      </ul>

      <h3>Data Sharing</h3>
      <p>
        We do not sell or rent your personal data. Information may be shared only
        with trusted service providers (such as WhatsApp or analytics services)
        strictly for operational purposes.
      </p>

      <h3>Data Security</h3>
      <p>
        We implement reasonable security practices to protect your data from
        unauthorized access, disclosure, or misuse.
      </p>

      <h3>Your Rights</h3>
      <p>
        You may request access, correction, or deletion of your personal data by
        contacting us.
      </p>

      <h3>Contact Us</h3>
      <p>
        Email: brightlifephysio@gmail.com<br />
        Phone: +91-9000666889
      </p>
    </div>
    </div>
  );
}
